import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  Typography,
} from "@material-tailwind/react";
import dayjs from 'dayjs';
import 'moment/locale/th'

import React, { useState } from "react";
import { SettingContext } from "../App";
import weekOfYear from 'dayjs/plugin/weekOfYear'
import advancedFormat from "dayjs/plugin/advancedFormat"
import { Autocomplete, Checkbox, FormControl, InputLabel, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import TimeRangeIgnoreYearSetting from "./TimeRangeIgnoreYearSetting";
import { TimeRangeSetting } from "./TimeRangeSetting";
import YearRangeSelection from "./YearRangeSelection";

dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)
// dayjs.locale("th");
// dayjs.extend(buddhistEra);

export function CaseCountSetting() {

    const { state, setting, setSetting } = React.useContext(SettingContext);

    const [activeTab, setActiveTab] = useState(state.setting.case_count.view);
    const [areaDataType, setAreaDataType] = useState(state.setting.case_count.area.data);
    const [timeDataType, setTimeDataType] = useState(state.setting.case_count.time.data);
    const [dataViewer, setDataViewer] = React.useState(state.setting.case_count.time.view);


    const [yearSelected, setYearSelected] = useState(state.setting.case_count.comparison.years.map(y => ({title: (Number(y)+543).toString(), key: Number(y)})))

    const data = [
    {
        label: "จำแนกตามพื้นที่",
        value: "area",
    },
    {
        label: "จำแนกตามเวลา",
        value: "time",
    },
    ];

    let year = Number(process.env.REACT_APP_START_YEAR)
    const current_year = new Date().getFullYear()
    const optionYear = Array.from(
        { length: (current_year - year) / 1 + 1 },
        (value, index) => {
            return {title: (year + index + 543 * 1).toString(), key: Number(year + index * 1)}
        }
    ).sort((a, b) => b.key - a.key)

    // if(yearSelected.length === 0){
    //     setYearSelected([optionYear[optionYear.map(e => e.title).indexOf((Number(state.setting.case_count.comparison.years[state.setting.case_count.comparison.years.length])+543).toString())]])
    // }

    const handleYearSelected = (event, years) => {
        years = years.sort((a, b) => a.key - b.key)
        setYearSelected(years)
        let _setting = {...setting}
        _setting.case_count.comparison.years = years.map(y => y.key.toString())
        setSetting(_setting)
    };

    const handleTabChange = (value) => {
        setActiveTab(value)
        if(value !== setting.case_count.view){
            let _setting = {...setting}
            _setting.case_count.view = value
            setSetting(_setting)
        }
    }

    const handleAreaDataTypeChange = (event) => {
        setAreaDataType(event.target.value);
        if(setting.case_count.area.data !== event.target.value){
            let _setting = {...setting}
            _setting.case_count.area.data = event.target.value
            setSetting(_setting)
        }
    };

    const handleTimeDataTypeChange = (event) => {
        setTimeDataType(event.target.value);
        if(setting.case_count.time.data !== event.target.value){
            let _setting = {...setting}
            _setting.case_count.time.data = event.target.value
            setSetting(_setting)
        }
    };

    // const handleDataChange = (event, dataViewer) => {
    //     setDataViewer(dataViewer);
    //     if(setting.case_count.time.view !== dataViewer){
    //         let _setting = {...state.setting}
    //         _setting.case_count.time.view = dataViewer
    //         setSetting(_setting)
    //     }
        
    // };

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    return (
        <div>
            <Typography className="font-primary my-2 font-bold">รูปแบบการแสดงผล</Typography>
            <Tabs id="case-count-data-view" value={activeTab}>
                <TabsHeader
                    className="rounded-[4px] bg-red-50 border-red-200 border"
                    indicatorProps={{
                    className: "bg-red-900 shadow-none !text-gray-900",
                    }}
                >
                    {data.map(({ label, value }) => (
                    <Tab
                        onClick={() => handleTabChange(value)}
                        className="font-primary"
                        activeClassName="text-white font-primary"
                        key={value}
                        value={value}
                    >
                        {label}
                    </Tab>
                    ))}
                </TabsHeader>
                <TabsBody
                    animate={{
                    initial: { y: 60 },
                    mount: { y: 0 },
                    unmount: { y: 60 },
                    }}
                >
                    <TabPanel key="area" value="area" className="px-0">
                        <FormControl className="w-full">
                            <InputLabel id="area-view-type-select-label" className="font-primary">ข้อมูล</InputLabel>
                            <Select
                                labelId="area-view-type-label"
                                id="area-view-type-select"
                                label="ข้อมูล"
                                value={areaDataType}
                                size="small"
                                className="text-left"
                                onChange={handleAreaDataTypeChange}
                                >
                                <MenuItem className="font-primary" value="cumulative">สะสม</MenuItem>
                                <MenuItem className="font-primary" value="compairation">เปรียบเทียบ</MenuItem>
                            </Select>
                        </FormControl>
                        {areaDataType==="cumulative"? <TimeRangeSetting /> : <TimeRangeIgnoreYearSetting/>}
                        {/* <TimeRangeSetting /> */}
                        {/* <TimeRangeIgnoreYearSetting/> */}
                        <Autocomplete
                            className="w-full"
                            multiple
                            size="small"
                            hidden={areaDataType==="cumulative"}
                            id="checkboxes-tags-demo"
                            options={optionYear}
                            value={yearSelected}
                            disableCloseOnSelect
                            disableClearable
                            onChange={handleYearSelected}
                            getOptionLabel={(option) => option.title}
                            isOptionEqualToValue={(option, value) => option.title === value.title}
                            ListboxProps={{className:"font-primary"}}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.title}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField 
                                    {...params} 
                                    label="เปรียบเทียบปี" 
                                    placeholder="เลือกปี" 
                                />
                            )}
                        />
                    </TabPanel>
                    <TabPanel key="time" value="time" className="px-0">
                        <FormControl className="w-full">
                            <InputLabel id="time-view-type-select-label" className="font-primary">ข้อมูล</InputLabel>
                            <Select
                                labelId="time-view-type-label"
                                id="time-view-type-select"
                                label="ข้อมูล"
                                value={timeDataType}
                                size="small"
                                className="text-left"
                                onChange={handleTimeDataTypeChange}
                                >
                                <MenuItem className="font-primary" value="continuous">ต่อเนื่อง</MenuItem>
                                <MenuItem className="font-primary" value="compairation">เปรียบเทียบ</MenuItem>
                            </Select>
                        </FormControl>
                        {timeDataType==="continuous"? <TimeRangeSetting /> : <TimeRangeIgnoreYearSetting/> }
                        <Autocomplete
                            className="w-full mt-4"
                            multiple
                            size="small"
                            hidden={timeDataType==="continuous"}
                            id="checkboxes-tags-demo"
                            options={optionYear}
                            value={yearSelected}
                            disableCloseOnSelect
                            disableClearable
                            onChange={handleYearSelected}
                            getOptionLabel={(option) => option.title}
                            isOptionEqualToValue={(option, value) => option.title === value.title}
                            ListboxProps={{className:"font-primary"}}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.title}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField 
                                    {...params} 
                                    label="เปรียบเทียบปี" 
                                    placeholder="เลือกปี" 
                                />
                            )}
                        />
                    </TabPanel>
                </TabsBody>
            </Tabs>
        </div>
        
    );
}
